import axios from 'axios'
import { apiUrl } from 'src/const'
import LocalStorageService from './LocalStorageService'

let httpClient = ''
let multipartHttpClient = ''

export default class ApiService {
  constructor() {
    const cvisa_info = LocalStorageService.obterItem('_pmpv-cmia')

    const jwt = cvisa_info ? cvisa_info.jwt : null

    if (jwt) {
      httpClient = axios.create({
        baseURL: apiUrl, //PROD
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + jwt,
        },
      })

      multipartHttpClient = axios.create({
        baseURL: apiUrl, //PROD
        headers: {
          'content-type': 'multipart/form-data',
          Accept: 'application/json',
          Authorization: 'Bearer ' + jwt,
        },
      })
    } else {
      httpClient = axios.create({
        baseURL: apiUrl, //PROD
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json',
        },
      })
    }
  }

  get(url) {
    return httpClient.get(url)
  }

  post(url, objeto) {
    return httpClient.post(url, objeto)
  }

  multiPost(url, objeto) {
    const result = multipartHttpClient.post(url, objeto)
    return result
  }

  put(url, objeto) {
    return httpClient.put(url, objeto)
  }

  async delete(url, objeto) {
    const resp = await httpClient.delete(url, objeto)
    return resp
  }
}
